import { z } from 'zod'

export default z.object({
  __typename: z.literal('EquipmentVista').default('EquipmentVista'),
  id: z.string(),
})
